import React from 'react';
import {
  EMAIL_BODY_BUTTON,
  EMAIL_BODY_IMAGE,
  EMAIL_BODY_TEXT,
  EMAIL_BUTTON_COMPONENT,
  EMAIL_IMAGE_COMPONENT,
  EMAIL_TEXT_COMPONENT,
  EMAIL_BODY_DIVIDER,
  EMAIL_DIVIDER_COMPONENT,
} from '../../constants/EmailServicesConst';
import ButtonComponent from './services-library/button-component/ButtonComponent';
import DividerComponent from './services-library/divider-component/DividerComponent';
import ImageComponent from './services-library/image-component/ImageComponent';
import TextComponent from './services-library/text-component/TextComponent';

const EmailBodySubComponent = (props) => {
  const { onItemChange, componentObj, activeNdx, onRemoveComponent, groupId } = props;

  const switchComponent = () => {
    switch (componentObj?.subId) {
      case EMAIL_BODY_IMAGE:
        return (
          <ImageComponent
            componentId={EMAIL_IMAGE_COMPONENT}
            subId={EMAIL_BODY_IMAGE}
            onItemChange={onItemChange}
            componentObj={componentObj}
            isRemovable={true}
            activeNdx={activeNdx}
            isHex={true}
            onRemoveComponent={onRemoveComponent}
            groupId={groupId}
          />
        );
      case EMAIL_BODY_TEXT:
        return (
          <TextComponent
            componentId={EMAIL_TEXT_COMPONENT}
            subId={EMAIL_BODY_TEXT}
            onItemChange={onItemChange}
            componentObj={componentObj}
            activeNdx={activeNdx}
            isHex={true}
            isVariable={true}
            isFontStyleDD={true}
            isRemovable={true}
            onRemoveComponent={onRemoveComponent}
            isHyperlink={true}
            maxLength={2000}
          />
        );
      case EMAIL_BODY_BUTTON:
        return (
          <ButtonComponent
            componentId={EMAIL_BUTTON_COMPONENT}
            subId={EMAIL_BODY_BUTTON}
            onItemChange={onItemChange}
            componentObj={componentObj}
            activeNdx={activeNdx}
            isRemovable={true}
            onRemoveComponent={onRemoveComponent}
          />
        );
      case EMAIL_BODY_DIVIDER:
        return (
          <DividerComponent
            componentId={EMAIL_DIVIDER_COMPONENT}
            subId={EMAIL_BODY_DIVIDER}
            onItemChange={onItemChange}
            componentObj={componentObj}
            isRemovable={true}
            activeNdx={activeNdx}
            onRemoveComponent={onRemoveComponent}
          />
        );
      default:
        break;
    }
  };

  return <>{switchComponent()}</>;
};

export default EmailBodySubComponent;
